export { default as Header } from './Header';
export { default as Content } from './Content';
export { default as Footer } from './Footer';
export { default as ErrorMessage } from './ErrorMessage';
export { default as FooterButtons } from './FooterButtons';
